import { render, staticRenderFns } from "./CountryBICList.vue?vue&type=template&id=c889f350&"
import script from "./CountryBICList.vue?vue&type=script&lang=js&"
export * from "./CountryBICList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports